import * as tslib_1 from "tslib";
import { NgModule, ANALYZE_FOR_ENTRY_COMPONENTS } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyForm } from './components/formly.form';
import { FormlyField } from './components/formly.field';
import { FormlyAttributes } from './components/formly.attributes';
import { FormlyConfig, FORMLY_CONFIG_TOKEN } from './services/formly.config';
import { FormlyFormBuilder } from './services/formly.form.builder';
import { FormlyValidationMessages } from './services/formly.validation-messages';
import { FormlyPubSub } from './services/formly.event.emitter';
import { FormlyGroup } from './components/formly.group';
var FORMLY_DIRECTIVES = [FormlyForm, FormlyField, FormlyAttributes, FormlyGroup];
var FormlyModule = FormlyModule_1 = (function () {
    function FormlyModule() {
    }
    FormlyModule.forRoot = function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: FormlyModule_1,
            providers: [
                FormlyFormBuilder,
                FormlyConfig,
                FormlyPubSub,
                FormlyValidationMessages,
                { provide: FORMLY_CONFIG_TOKEN, useValue: config, multi: true },
                { provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: config, multi: true },
            ],
        };
    };
    FormlyModule.forChild = function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: FormlyModule_1,
            providers: [
                { provide: FORMLY_CONFIG_TOKEN, useValue: config, multi: true },
                { provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: config, multi: true },
            ],
        };
    };
    return FormlyModule;
}());
FormlyModule = FormlyModule_1 = tslib_1.__decorate([
    NgModule({
        declarations: FORMLY_DIRECTIVES,
        entryComponents: [FormlyGroup],
        exports: FORMLY_DIRECTIVES,
        imports: [
            CommonModule,
            ReactiveFormsModule,
        ],
    })
], FormlyModule);
export { FormlyModule };
var FormlyModule_1;
//# sourceMappingURL=core.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/core.module.js
// module id = 765
// module chunks = 3